export const PageContentLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className="bg-gxe-bg-light flex-1 px-10 py-7">{children}</div>;
};
